import {
  EventDetailsResponse,
  EventInfoResponse,
  GetPerformanceAvailabilitiesResponse,
  GetPerformancesResponse,
  PerformanceResult,
  PerformerInfoResponse,
  ReserveTicketsResponse,
  SearchResponse,
  VenueInfoResponse,
} from '@grpc-clients/external/mercury/v1/entertainment/entertainment.pb';
import { createFeatureSelector } from '@ngrx/store';
import { EntertainmentForm } from '@pages/entertainment/models/entertainment-tickets-config';
import { SearchStateResults } from '@shared/models/search-state';
import { CardPreferenceState } from '@shared/shared/modules/card/models/card';
import { FormData } from '@shared/store/models/form-data';
import * as fromEntertainmentSearch from './entertainment-search.reducer';
import * as fromEntertainmentTicketDetailsPage from './entertainment-ticket-details.reducer';
import * as fromEntertainmentTicketSearch from './entertainment-ticket-search.reducer';
export interface EntertainmentSearchStateResults extends SearchStateResults {
  hasFollowAnchor?: boolean;
  ribbon?: { filled: boolean; text: string; type: string };
}

export interface EntertainmentSearchState {
  results: EntertainmentSearchStateResults;
  preferences: CardPreferenceState;
}
export interface EntertainmentTicketState {
  entertainmentTicketForm: FormData<EntertainmentForm>;
  loaded: boolean;
  loading: boolean;
  results: SearchResponse;
  eventResult: EventInfoResponse | PerformerInfoResponse | VenueInfoResponse;
  paginationResponse: IPaginatedResponse;
  pageIndex: number;
}

export interface IPaginatedResponse {
  results: ExtendedPerformanceResult[];
  isPageLoaded: boolean;
  isPageLoading: boolean;
}

export interface ExtendedPerformanceResult extends PerformanceResult {
  ribbon?: { filled: boolean; text: string; type: string };
}

export interface EntertainmentTicketDetailsState {
  eventDetails: EventDetailsResponse;
  loaded: boolean;
  loading: boolean;
  calendarDetails: CalendarInfo;
  performancesAvailability: AvailabilityInfo;
  reserveTickets: ReserveTicketsInfo;
  dynamicSeatMapDirty: boolean;
}

export interface ReserveTicketsInfo {
  data: ReserveTicketsResponse;
  paymentToken: string;
  performanceId: number;
}
export interface CalendarInfo {
  isCalendarLoaded: boolean;
  isCalendarLoading: boolean;
  performances: GetPerformancesResponse;
}

export interface AvailabilityInfo {
  isPerformanceAvailabilityLoaded: boolean;
  isPerformanceAvailabilityLoading: boolean;
  performancesAvailability: GetPerformanceAvailabilitiesResponse;
}

export const pageCount = 20;

export const reducers = fromEntertainmentSearch.reducer;
export const ticketReducer = fromEntertainmentTicketSearch.reducer;
export const ticketDetailReducer = fromEntertainmentTicketDetailsPage.reducer;

export const getEntertainmentSearchState = createFeatureSelector<EntertainmentSearchState>('entertainment-search');

export const getEntertainmentTicketSearchState =
  createFeatureSelector<EntertainmentTicketState>('entertainment-ticket-search');

export const getEntertainmentTicketDetailsSearchState = createFeatureSelector<EntertainmentTicketDetailsState>(
  'entertainment-ticket-details-search'
);
